import React from "react";
import {
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdb-react-ui-kit";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import "./ContactSection.css";

const DEFAULTS = {
  name: "TEANSARI",
  address: "I.E.S. Miguel de Mañara, Calle Cultura, s/n, La Rinconada",
  email: "teansarisanjose@gmail.com",
  tagline: "Charlas, colaboraciones, funciones y talleres. ¡Hablemos!",
  social_instagram: "https://www.instagram.com/teansarisj",
  social_facebook: "https://www.facebook.com/profile.php?id=100057086515415",
  social_youtube: "https://www.youtube.com/@teatroteansari",
  social_tiktok: "",
  phone: "",
  whatsapp: "",
};

class ContactSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contact: {
        name: DEFAULTS.name,
        address: DEFAULTS.address,
        location: null,
        email: DEFAULTS.email,
        phone: null,
        whatsapp: null,
        tagline: DEFAULTS.tagline,
        social: {
          instagram: DEFAULTS.social_instagram,
          facebook: DEFAULTS.social_facebook,
          youtube: DEFAULTS.social_youtube,
          tiktok: "",
        },
        show: {
          email: true,
          phone: true,
          whatsapp: true,
          instagram: true,
          facebook: true,
          youtube: true,
          tiktok: true,
        },
        formConfig: { subject: true, phone: true, gdprText: "Acepto la política de privacidad" },
      },
      formEnabled: true,
    };
  }

  componentDidMount() {
    this.loadContact();
  }

  async loadContact() {
    if (this.props.onLoading) this.props.onLoading(true);
    try {
      const response = await doFetch("TEAN", "getSiteContentByPrefix?prefix=CONTACT_");
      const json = await response.json();
      const items = json && json.DATA ? json.DATA : [];
      if (items.length > 0) {
        const vals = {};
        items.forEach((item) => {
          const key = item.contentKey.replace("CONTACT_", "");
          vals[key] = item.configValue ?? "";
        });
        this.setState((prev) => ({
          contact: {
            ...prev.contact,
            name: vals.name || DEFAULTS.name,
            address: vals.address || DEFAULTS.address,
            email: vals.email || DEFAULTS.email,
            tagline: vals.tagline || DEFAULTS.tagline,
            phone: vals.phone || "",
            whatsapp: vals.whatsapp || "",
            social: {
              instagram: vals.social_instagram || DEFAULTS.social_instagram,
              facebook: vals.social_facebook || DEFAULTS.social_facebook,
              youtube: vals.social_youtube || DEFAULTS.social_youtube,
              tiktok: vals.social_tiktok || "",
            },
            show: {
              email: vals.show_email !== "false",
              phone: vals.show_phone !== "false",
              whatsapp: vals.show_whatsapp !== "false",
              instagram: vals.show_social_instagram !== "false",
              facebook: vals.show_social_facebook !== "false",
              youtube: vals.show_social_youtube !== "false",
              tiktok: vals.show_social_tiktok !== "false",
            },
          },
          formEnabled: vals.form_enabled !== "false",
        }));
      }
    } catch (err) {
      console.error("Error loading contact data:", err);
    } finally {
      if (this.props.onLoading) this.props.onLoading(false);
    }
  }

  buildMapSrc = () => {
    const { address, location } = this.state.contact;
    if (location && location.lat && location.lng) {
      return `https://www.google.com/maps?q=${location.lat},${location.lng}&z=15&output=embed`;
    }
    return `https://www.google.com/maps?q=${encodeURIComponent(address)}&z=15&output=embed`;
  };

  renderHours() {
    const { hours } = this.state.contact;
    if (!hours || !hours.length) return null;
    return (
      <table className="hours-table">
        <tbody>
          {hours.map((h, i) => (
            <tr key={i}>
              <td className="hours-day">{h.day}</td>
              <td className="hours-time">
                {h.open}
                {h.close ? ` – ${h.close}` : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    const { name, address, email, phone, whatsapp, social, show, formConfig, tagline } = this.state.contact;
    const { formEnabled } = this.state;

    return (
      <section className="contact-section">
        {/* Hero */}
        <div className="contact-hero">
          <div className="contact-hero-content">
            <h2 className="contact-title">
              <span className="contact-title-main">Contáctanos</span>
              <span className="contact-title-sub">— {name}</span>
            </h2>
            <p className="contact-tagline">{tagline}</p>
          </div>
        </div>

        {/* Tarjetas rápidas */}
        <MDBRow className="g-4 quick-cards">
          <MDBCol md="6">
            <MDBCard className="contact-card">
              <MDBCardBody>
                <MDBCardTitle><MDBIcon icon="map-marker-alt" className="me-2"/> Dirección</MDBCardTitle>
                <MDBCardText>{address}</MDBCardText>
                <a className="link-accent" href={`https://maps.google.com/?q=${encodeURIComponent(address)}`} target="_blank" rel="noreferrer">
                  Ver en Google Maps
                </a>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol md="6">
            <MDBCard className="contact-card">
              <MDBCardBody>
                <MDBCardTitle><MDBIcon icon="envelope" className="me-2"/> Email</MDBCardTitle>
                {show?.email !== false && (
                  <MDBCardText><a className="link-plain" href={`mailto:${email}`}>{email}</a></MDBCardText>
                )}
                {show?.email !== false && (
                  <MDBBtn outline size="sm" tag="a" href={`mailto:${email}`}>Escríbenos</MDBBtn>
                )}
                {show?.email === false && (
                  <MDBCardText className="text-muted">Email no disponible</MDBCardText>
                )}
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>

        {/* Bloque principal: info + formulario */}
        <MDBRow className="g-4 align-items-stretch mt-1">
          <MDBCol lg="6" className="">
            <MDBCard className="contact-card h-100">
              <MDBCardBody>
                <MDBCardTitle className="mb-3">Escríbenos</MDBCardTitle>
                <form onSubmit={(e)=>e.preventDefault()}>
                  <MDBRow className="mb-3">
                    <MDBCol md="6"><MDBInput label="Nombre" type="text" required disabled={!formEnabled}/></MDBCol>
                    <MDBCol md="6"><MDBInput label="Email" type="email" required disabled={!formEnabled}/></MDBCol>
                  </MDBRow>
                  {formConfig?.phone && (
                    <MDBInput className="mb-3" label="Teléfono" type="tel" disabled={!formEnabled} />
                  )}
                  {formConfig?.subject && (
                    <MDBInput className="mb-3" label="Asunto" type="text" disabled={!formEnabled} />
                  )}
                  <MDBInput className="mb-3" label="Mensaje" type="textarea" rows={5} required disabled={!formEnabled} />
                  {formConfig?.gdprText && (
                    <label className="gdpr mb-3 d-block">
                      <input type="checkbox" required className="me-2" disabled={!formEnabled}/>{formConfig.gdprText}
                    </label>
                  )}
                  <div className="d-flex justify-content-end">
                    <MDBBtn disabled={!formEnabled}>Enviar</MDBBtn>
                  </div>
                </form>

                {/* Sociales */}
                <div className="social mt-4">
                  {social?.instagram && show?.instagram !== false && (
                    <a className="social-link" href={social.instagram} target="_blank" rel="noreferrer">
                      <MDBIcon fab icon="instagram"/> Instagram
                    </a>
                  )}
                  {social?.facebook && show?.facebook !== false && (
                    <a className="social-link" href={social.facebook} target="_blank" rel="noreferrer">
                      <MDBIcon fab icon="facebook"/> Facebook
                    </a>
                  )}
                  {social?.youtube && show?.youtube !== false && (
                    <a className="social-link" href={social.youtube} target="_blank" rel="noreferrer">
                      <MDBIcon fab icon="youtube"/> YouTube
                    </a>
                  )}
                  {social?.tiktok && show?.tiktok !== false && (
                    <a className="social-link" href={social.tiktok} target="_blank" rel="noreferrer">
                      <MDBIcon fab icon="tiktok"/> TikTok
                    </a>
                  )}
                  {phone && show?.phone !== false && (
                    <a className="social-link" href={`tel:${phone}`} rel="noreferrer">
                      <MDBIcon fas icon="phone"/> {phone}
                    </a>
                  )}
                  {whatsapp && show?.whatsapp !== false && (
                    <a className="social-link" href={`https://wa.me/${whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer">
                      <MDBIcon fab icon="whatsapp"/> WhatsApp
                    </a>
                  )}
                </div>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          <MDBCol lg="6">
            <MDBCard className="contact-card h-100">
              <MDBCardBody>
                <div className="map-wrapper mt-3">
                  <iframe
                    title="Ubicación en Google Maps"
                    src={this.buildMapSrc()}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </section>
    );
  }
}

export default ContactSection;
